import { FC } from 'react'

import { Button } from '@/components/Button/Button'
import { focusIds } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

export const LoginButton: FC<{ goToLogin: () => void; label?: string }> = ({
  goToLogin,
  label = 'login',
}) => {
  const { t } = useCommonTranslation()

  return (
    <Button
      iconSrc={icons.register.loginIcon}
      text={t(label)}
      focusId={`${focusIds.EVENT_PAGE}_${focusIds.LOGIN}`}
      onClick={goToLogin}
    />
  )
}
